module.exports = __webpack_public_path__ + "img/about-pic-3.5c9cd1e8.jpg";